module.exports = __webpack_public_path__ + "static/web-c176344352f3960fdd950b4408d91f15.svg";